import call from "@/conn-global/api";
export default {
  postLayananScan: async ({ commit }, data) => {
    try {
      let response = await call.post("/v1/transaksi/get_layanan", data);

      // console.log("Request Data:", data);
      // console.log("Response Data:", response.data);
      commit("setDataLayanan", response.data.data);
      return response;
    } catch (error) {
      console.error("API Error:", error);
      return error.response;
    }
  },
  getAkunEpay: async ({ commit }, dataToken) => {
    await call
      .get("/v1/transaksi/get_epayment/" + dataToken, true)
      .then((res) => {
        if (res != undefined) {
          commit("chooseAkunEpay", res.data.data);
        }
      })
      .catch((err) => {
        alert(err);
      });
  },
  postCreateSnapTransaksi: async ({ commit }, data) => {
    try {
      let response = await call.post(
        "/v1/transaksi/create_snap_transaksi",
        data
      );

      // console.log("Request Data:", data);
      // console.log("Response Data:", response.data);
      commit("createSnapTransaksi", response.data.data);
      return response;
    } catch (error) {
      console.error("API Error:", error);
      return error.response;
    }
  },

  getCustomerGlobal: async ({ commit }, dataToken) => {
    try {
      const response = await call.get(
        "/v1/dashboard/customer_global/" + dataToken,
        true
      );

      if (response.data.status === 200) {
        commit("customerGlobal", response.data.data);
      } else if (response.status === 404) {
        console.error("Customer data not found");
      } else {
        console.error(
          "Unexpected error:",
          response.status,
          response.data.message
        );
      }
    } catch (error) {
      console.error("Error:", error);
      alert(error.message);
    }
  },
};
